import { Graphics } from 'pixi.js';

// Full-screen additive flash overlay — fired on bomb / boss-kill / phase-shift impact.
// `trigger(alpha, color)` sets target alpha (max-merged), `tick(dt, W, H)` decays + renders.
export class FlashOverlay {
  view: Graphics;
  private alpha = 0;
  private color = 0xffffff;

  constructor() {
    this.view = new Graphics();
    this.view.rect(0, 0, 1, 1);
    this.view.fill({ color: 0xffffff });
    this.view.alpha = 0;
    this.view.blendMode = 'add';
  }

  trigger(alpha: number, color = 0xffffff): void {
    this.alpha = Math.max(this.alpha, alpha);
    this.color = color;
  }

  tick(dt: number, W: number, H: number): void {
    if (this.alpha > 0.001) {
      this.view.scale.set(W, H);
      this.view.tint = this.color;
      this.view.alpha = this.alpha;
      this.alpha *= Math.pow(0.001, dt); // exponential decay, ~6×/sec
      if (this.alpha < 0.01) this.alpha = 0;
    } else if (this.view.alpha !== 0) {
      this.view.alpha = 0;
    }
  }
}
